import { FetchClient } from "../../utils/fetchClient";

export async function getIsServiceableZipCode(brandId = 0, franchiseId = 0, zipCode = "") {
    return await FetchClient(`/jobs/is-serviceable-zip-code?brandId=${brandId}&franchiseId=${franchiseId}&zipCode=${zipCode}`).GET({});
}
